/* Keep external bundle additions from opening Zipify with stale cart data. */
(() => {
  let pending = false;
  let cancelled = false;
  let status;
  let bundleOpening = false;
  let bundleTimeout;
  const dutch = document.documentElement.lang.startsWith('nl');

  function announce(message) {
    if (!status) {
      status = document.createElement('div');
      status.setAttribute('role', 'status');
      status.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);z-index:2147483646;background:#262626;color:#fff;padding:14px 20px;border-radius:8px;max-width:90vw;text-align:center;box-shadow:0 4px 20px #0003';
      document.body.appendChild(status);
    }
    status.textContent = message;
    status.hidden = false;
  }

  window.addEventListener('ocu:cart:close', () => { cancelled = true; });

  // Kaching calls upcartOpenCart BEFORE _addAllItemsToCart and only calls
  // upcartRefreshCart AFTER it resolves. Zipify reassigns these callbacks in
  // its integration init on every add; wrap that initializer, not just globals.
  function installBundleBridge() {
    const integration = window.Zipify?.Cart?.integrations?.KachingBundles;
    if (!integration || typeof integration.init !== 'function') return false;
    if (integration.nolphyReadyBridge) return true;
    integration.nolphyReadyBridge = true;
    const initialize = integration.init;
    integration.init = function (...args) {
      const result = initialize.apply(this, args);
      if (!this.present) return result;
      window.upcartOpenCart = () => {
        bundleOpening = true;
        clearTimeout(bundleTimeout);
        announce(dutch ? 'Bundel toevoegen…' : 'Adding your bundle…');
        bundleTimeout = setTimeout(() => {
          bundleOpening = false;
          announce(dutch ? 'Toevoegen duurt langer dan verwacht. Controleer je winkelwagen voordat je opnieuw toevoegt.' : 'Adding is taking longer than expected. Check your cart before adding again.');
        }, 20000);
      };
      window.upcartRefreshCart = () => {
        clearTimeout(bundleTimeout);
        if (bundleOpening) {
          bundleOpening = false;
          window.dispatchEvent(new CustomEvent('ocu:cart:open', {
            detail: { triggerElement: this.triggerElement }
          }));
        } else {
          window.dispatchEvent(new CustomEvent('ocu:cart:update'));
        }
      };
      return result;
    };
    integration.init();
    return true;
  }
  if (!installBundleBridge()) {
    let attempts = 0;
    const startup = setInterval(() => {
      if (installBundleBridge() || ++attempts >= 150) clearInterval(startup);
    }, 100);
    window.addEventListener('ocu:cart:loaded', installBundleBridge);
    window.addEventListener('kaching-bundles-initialized', installBundleBridge);
  }

  window.addEventListener('ocu:cart:open', async (event) => {
    // Zipify's native add flow already manages its own loading state.
    if (event.detail?.preventUpdate || typeof window.UPDATE_CART !== 'function') return;
    event.stopImmediatePropagation();
    if (pending) return;
    pending = true;
    cancelled = false;
    announce(dutch ? 'Winkelwagen laden…' : 'Loading your cart…');
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
        signal: controller.signal
      });
      if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
      const cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error('Invalid cart response');
      // Supply the confirmed cart so Zipify does not issue another fetch.
      await window.UPDATE_CART({ detail: { cart } });
      // Let the drawer render the new contents before making it visible.
      await new Promise(requestAnimationFrame);
      if (!cancelled) {
        window.dispatchEvent(new CustomEvent('ocu:cart:open', {
          detail: { ...event.detail, preventUpdate: true }
        }));
      }
      status.hidden = true;
    } catch (error) {
      announce(dutch
        ? 'Winkelwagen laden lukt niet. Open je winkelwagen opnieuw om te controleren wat is toegevoegd.'
        : 'Unable to load your cart. Open your cart again to check what was added.');
      console.warn('[NOLPHY cart]', error);
    } finally {
      clearTimeout(timeout);
      pending = false;
    }
  }, true);
})();
